import React from 'react';
import styled from 'styled-components';
import QRCode from 'react-qr-code';

import useI18n from '../../i18n';
import FullpageLoader from '../../Components/FullpageLoader';

const Wrapper = styled.div`
  padding-top: ${() => window.headerHeight}px;
  height: 100%;
`;

const Inner = styled.div`
  padding: 0 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Title = styled.h2`
  font-weight: 600;
  letter-spacing: 0px;
  line-height: 32px;
  text-align: center;
`;

const QRWrapper = styled.div`
  padding: 28px 0;
`;

type Props = {
  userId: string;
};

const LeatLoyaltyView: React.FC<Props> = ({ userId }: Props) => {
  const { i18n } = useI18n();

  if (!userId) {
    return <FullpageLoader />;
  }

  return (
    <Wrapper>
      <Inner>
        <Title>{i18n('LeatLoyalty.Title')}</Title>
        <QRWrapper>
          <QRCode value={userId} />
        </QRWrapper>
      </Inner>
    </Wrapper>
  );
};

export default LeatLoyaltyView;
